// @flow

import styled from 'styled-components';

const FeatureItem = styled.div(
  props => `
  padding-bottom: 65px;
`
);

export default FeatureItem;